/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-duplicate-props */
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import SwitchToggle from "../../../components/SwitchToggle";

import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { Box } from "@mui/material";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Tooltip, Area, AreaChart, Cell, Pie, PieChart } from "recharts";

export interface KpiDonutItem {
  label: string;
  value: number;
  unit: string;
  trend: number;          // positive / negative change
  trendLabel: string;     // small text below value
  color: string;          // active arc
  bg: string;             // remaining arc
}

const performanceData = [
  { name: "Vendors", a: 18, b: 15, c: 12 },
  { name: "Vendors", a: 22, b: 18, c: 14 },
  { name: "Pricing", a: 26, b: 20, c: 17 },
  { name: "Listings", a: 40, b: 28, c: 22 },
  { name: "Marketing", a: 32, b: 26, c: 20 },
  { name: "Bassing", a: 44, b: 30, c: 24 },
  { name: "Ruding", a: 38, b: 34, c: 26 },
  { name: "Disputes", a: 46, b: 38, c: 30 }
];

const roiData = [
  { name: "Savings", value: 305.8 },
  { name: "Cost", value: 42.6 },
];

export const kpiDonutData: KpiDonutItem[] = [
  {
    label: "Success Rate",
    value: 96.8,
    unit: "%",
    trend: +1.4,
    trendLabel: "↑ 1.4%",
    color: "#4caf50",
    bg: "#e8f5e9",
  },
  {
    label: "Autonomy Level",
    value: 44,
    unit: "%",
    trend: +3.1,
    trendLabel: "↑ 3.1%",
    color: "#26c6da",
    bg: "#e0f7fa",
  },
  {
    label: "Avg. Latency",
    value: 780,
    unit: "ms",
    trend: -4.9,
    trendLabel: "↓ 4.9%",
    color: "#ff9800",
    bg: "#fff3e0",
  },
  {
    label: "Most Failbacks",
    value: 7,
    unit: "%",
    trend: +2.1,
    trendLabel: "↑ 2.1",
    color: "#9c27b0",
    bg: "#f3e5f5",
  },
];

const AICommandCenter = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(true);

  return (
    <>
      {/* ================= PAGE TITLE ================= */}
      <div className="main_title ai_command_page d_flex">
        <div className="lt">
          <h1>AI Command Center</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Controls & AI Behaviour Management
          </p>
        </div>

        <div className="right_s">
          <p>AI Kill Switch</p>
          <SwitchToggle
            onChange={(e) => setIsChecked(e.target.checked)}
            label={isChecked ? "On" : "Off"}
          />
        </div>
      </div>


      <div className="gap_m">
        {/* ================= STATS ================= */}
        <div className="w_100 cards">
          <div className="stats_boxes ai_insight_stat gap_m">
            {/* AI Cost */}
            <a className="cards" style={{ backgroundColor: "#FEE0C6" }}>
              <div className="data_top">
                <p>AI Cost</p>
                <figure style={{ backgroundColor: "#ED9A4D" }}>
                  <AttachMoneyOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <h2>AED 12,450</h2>

              <div className="ai_insight">
                <span>Today · MTD</span>
              </div>
            </a>

            {/* Time Saved */}
            <a className="cards" style={{ backgroundColor: "#DFF3EE" }}>
              <div className="data_top">
                <p>Time Saved</p>
                <figure style={{ backgroundColor: "#08C3A5" }}>
                  <AccessTimeOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <h2>116 hrs</h2>

              <div className="ai_insight success">
                <span>Today · MTD</span>
              </div>
            </a>

            {/* AI Usage */}
            <a className="cards" style={{ backgroundColor: "#DEEDFD" }}>
              <div className="data_top">
                <p>AI Usage</p>
                <figure style={{ backgroundColor: "#83aff9" }}>
                  <QueryStatsOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <h2>18.2k <sub>requests</sub></h2>

              <div className="ai_insight neutral">
                <span>
                  Success Rate : <strong>96.8%</strong>
                </span>
              </div>
            </a>

            {/* Autonomy Level */}
            <a className="cards" style={{ backgroundColor: "#F5F5F6" }}>
              <div className="data_top">
                <p>Autonomy Level</p>
                <figure style={{ backgroundColor: "#9497A0" }}>
                  <SettingsSuggestOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <h2>44%</h2>

              <div className="ai_insight neutral">
                <span>In Limited rollout</span>
                <ul>
                  <li>Logistics</li>
                  <li>Marketing</li>
                </ul>
              </div>
            </a>

            {/* Risk Alerts */}
            <a className="cards" style={{ backgroundColor: "#FCF8F2" }}>
              <div className="data_top">
                <p>Top Risk Alerts</p>
                <figure style={{ backgroundColor: "#EAAE6E" }}>
                  <WarningAmberOutlinedIcon fontSize="large" />
                </figure>
              </div>
              <h2>
                2 <sub>drift detected</sub>
                <br />
                1 <sub>UAE compliance at risk</sub>
              </h2>
            </a>

            {/* Data Quality */}
            <a className="cards" style={{ backgroundColor: "#F3ECFB" }}>
              <div className="data_top">
                <p>Data Quality</p>
                <figure style={{ backgroundColor: "#9B87EA" }}>
                  <VerifiedOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <h2>93%</h2>

              <div className="ai_insight success">
                <span>2 data issues detected</span>
              </div>
            </a>
          </div>
        </div>

        <div className="cards w_100">
          <div className="cards_header mb_20">
            <div className="left_s">
              <h2>AI Overview</h2>
            </div>
            <div className="right_s">
              <p>
                <span>7 days</span>
                <span>14 days</span>
                <span>30 days</span>
              </p>
            </div>
          </div>
          <div className="gap_m">
            <div className="w_60">
              <Box height={260}>
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={performanceData}>
                    <defs>
                      <linearGradient id="orange" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffb74d" stopOpacity={0.5} />
                        <stop offset="100%" stopColor="#ffb74d" stopOpacity={0} />
                      </linearGradient>

                      <linearGradient id="purple" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#9c27b0" stopOpacity={0.4} />
                        <stop offset="100%" stopColor="#9c27b0" stopOpacity={0} />
                      </linearGradient>

                      <linearGradient id="teal" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#26c6da" stopOpacity={0.4} />
                        <stop offset="100%" stopColor="#26c6da" stopOpacity={0} />
                      </linearGradient>
                    </defs>

                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="name" />
                    <YAxis tickFormatter={(v) => `${v}.00M`} />
                    <Tooltip />

                    <Area
                      type="monotone"
                      dataKey="a"
                      stroke="#ff9800"
                      fill="url(#orange)"
                      strokeWidth={2}
                    />

                    <Area
                      type="monotone"
                      dataKey="b"
                      stroke="#9c27b0"
                      fill="url(#purple)"
                      strokeWidth={2}
                    />

                    <Area
                      type="monotone"
                      dataKey="c"
                      stroke="#26c6da"
                      fill="url(#teal)"
                      strokeWidth={2}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </Box>
              <div className="ai-kpi-bar">
                <div className="kpi-item">
                  <h2>7865</h2>
                  <p>Today</p>
                </div>
                <div className="kpi-item">
                  <h2>
                    1.85 <span>AED / request</span>
                  </h2>
                  <p>Total requests</p>
                </div>
                <div className="kpi-item">
                  <h2>96.8%</h2>
                  <p>Success rate</p>
                </div>
                <div className="kpi-item">
                  <h2>
                    780 <span>ms</span>
                  </h2>
                  <p>Avg. latency</p>
                </div>
              </div>
            </div>
            <div className="w_40">
              <Box height={260} position="relative">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={roiData}
                      dataKey="value"
                      cx="50%"
                      cy="50%"
                      innerRadius={85}
                      outerRadius={115}
                      startAngle={90}
                      endAngle={-270}
                      paddingAngle={2}
                    >
                      <Cell fill="#26c6da" />
                      <Cell fill="#ffd166" />
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
                {/* Center Content */}
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    pointerEvents: "none",
                    textAlign: 'center'
                  }}
                >
                  <p style={{ fontSize: 12, color: "#6b7280", margin: 0 }}>
                    Cost vs Savings
                  </p>
                  <h2 style={{ margin: "4px 0", fontSize: 22, fontWeight: 700 }}>
                    AED 42.6K
                  </h2>
                  <p style={{ fontSize: 11, color: "#6b7280", margin: 0 }}>
                    Cost <span style={{ color: "#26c6da" }}>●</span> 305.8k
                  </p>
                </Box>
              </Box>
              <Box mt={2} sx={{ textAlign: "center" }}>
                <h2 style={{ margin: "0 0 6px", fontSize: 24, fontWeight: 700, lineHeight: 1.2 }}>AI ROI: +AED 263.2K</h2>
                <span
                  style={{
                    display: "inline-block",
                    padding: "4px 10px",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#059669",
                    background: "#e6f7f2",
                    borderRadius: 6,
                  }}
                >
                  +617%
                </span>
              </Box>
            </div>
          </div>
        </div>

        <div className="cards w_50">
          <div className="cards_header mb_20">
            <div className="left_s">
              <h2>Efficiency Metrics</h2>
            </div>
          </div>

          <div className="gap_m">
            {kpiDonutData.map((item) => (
              <div className="w_25">
                {/* Donut */}
                <Box height={120} position="relative">
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={[
                          { value: item.value },
                          { value: 100 - item.value },
                        ]}
                        dataKey="value"
                        cx="50%"
                        cy="50%"
                        innerRadius={40}
                        outerRadius={48}
                        startAngle={90}
                        endAngle={-270}
                        paddingAngle={1}
                      >
                        <Cell fill={item.color} />
                        <Cell fill={item.bg} />
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>


                  {/* Center Value */}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      pointerEvents: "none",
                    }}
                  >
                    <strong style={{ fontSize: 20 }}>
                      {item.value}
                      <span style={{ fontSize: 12 }}>{item.unit}</span>
                    </strong>

                    <span
                      style={{
                        fontSize: 11,
                        marginTop: 2,
                        color: item.trend >= 0 ? "#16a34a" : "#dc2626",
                      }}
                    >
                      {item.trendLabel}
                    </span>
                  </Box>
                </Box>

                {/* Label */}
                <Box mt={1} sx={{ textAlign: "center" }}>
                  <h2 style={{ margin: "0", fontSize: 14, fontWeight: 600, lineHeight: 1.2 }}>{item.label}</h2>
                </Box>
              </div>
            ))}
          </div>
        </div>

        <div className="w_50">
          <div className="gap_m">
            <div className="cards w_50">
              <div className="cards_header mb_20">
                <div className="left_s">
                  <h2>Recent Alerts</h2>
                </div>
              </div>
              <div className="ai-alerts">
                <div className="alert-item">
                  <span className="alert-icon warning"></span>
                  <div className="alert-content">
                    <p className="alert-title">
                      Latency deviation in Smart Pricing prompt
                    </p>
                    <p className="alert-meta">+27% avg delay</p>
                  </div>
                </div>
                <div className="alert-item">
                  <span className="alert-icon danger"></span>
                  <div className="alert-content">
                    <p className="alert-title">
                      Drift detected in Vendor segmentation model
                    </p>
                    <p className="alert-meta">+14% rea &nbsp; +4.1%</p>
                  </div>
                </div>
                <div className="alert-item">
                  <span className="alert-icon warning"></span>
                  <div className="alert-content">
                    <p className="alert-title">
                      Customer Segmentation flagged in refund
                    </p>
                    <p className="alert-meta">+4.1% in targeted segments.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="cards w_50">
              <div className="cards_header mb_20">
                <div className="left_s">
                  <h2>Top AI-Driven Metrics</h2>
                </div>
              </div>
              <div className="ai-metrics">
                <div className="metric-item">
                  <span className="metric-badge warning">1</span>
                  <div className="metric-content">
                    <p className="metric-title">
                      Smart Pricing <span>- AED 22.3K</span>
                    </p>
                    <p className="metric-desc">
                      Vendor avg profit margin increase by <strong>18.8%</strong> this week.
                    </p>
                  </div>
                </div>
                <div className="metric-item">
                  <span className="metric-badge teal">2</span>
                  <div className="metric-content">
                    <p className="metric-title">
                      Auto Categorization <span>- 18.2K</span>
                    </p>
                    <p className="metric-desc">
                      Vendors using auto categorization sales raised by <strong>+14.4%</strong>
                    </p>
                  </div>
                </div>
                <div className="metric-item">
                  <span className="metric-badge warning">3</span>
                  <div className="metric-content">
                    <p className="metric-title">
                      Customer Segmentation <span>- 12.9%</span>
                    </p>
                    <p className="metric-desc">
                      Vendor avg profit margin increase by <strong>18.8%</strong> this week.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AICommandCenter;